import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import NewStudentForm from "@/pages/NewStudentForm";
import ExistingStudentForm from "@/pages/ExistingStudentForm";
import ReturningStudentForm from "@/pages/ReturningStudentForm";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCourseGuide from "@/pages/AdminCourseGuide";
import AdminClassSettings from "@/pages/AdminClassSettings";
import AdminPackageBuilder from "@/pages/AdminPackageBuilder";
import AdminPerks from "@/pages/AdminPerks";
import AdminTrainingGuide from "@/pages/AdminTrainingGuide";
import ViewPackage from "@/pages/ViewPackage";
import TrackApplication from "@/pages/TrackApplication";
import ProtectedAdminRoute from "@/components/ProtectedAdminRoute";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/apply" element={<NewStudentForm />} />
          <Route path="/repackage" element={<ExistingStudentForm />} />
          <Route path="/returning" element={<ReturningStudentForm />} />
          <Route path="/track" element={<TrackApplication />} />
          <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
          <Route path="/admin/courses" element={<ProtectedAdminRoute><AdminCourseGuide /></ProtectedAdminRoute>} />
          <Route path="/admin/settings" element={<ProtectedAdminRoute><AdminClassSettings /></ProtectedAdminRoute>} />
          <Route path="/admin/perks" element={<ProtectedAdminRoute><AdminPerks /></ProtectedAdminRoute>} />
          <Route path="/admin/training" element={<ProtectedAdminRoute><AdminTrainingGuide /></ProtectedAdminRoute>} />
          <Route path="/admin/package/:studentId" element={<ProtectedAdminRoute><AdminPackageBuilder /></ProtectedAdminRoute>} />
          <Route path="/view-package/:packageId" element={<ViewPackage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#121212',
            color: '#EDEDED',
            border: '1px solid #2A2A2A',
          },
        }}
      />
    </div>
  );
}

export default App;
